import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress, colors } from '@material-ui/core';
import { makeStyles, styled } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  normal: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'green',
    },
  },
  lowNormal: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'goldenrod',
    },
  },
  highNormal: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'goldenrod',
    },
  },
  lowWarn: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'darkorange',
    },
  },
  highWarn: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'darkorange',
    },
  },
  lowCritical: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'orangered',
    },
  },
  highCritical: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'orangered',
    },
  },
  error: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: 'red',
    },
  },
  default: {
    '& .MuiLinearProgress-colorPrimary': {
      backgroundColor: colors.grey[400],
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: colors.grey[400],
    },
  },
}));

const BorderLinearProgress = styled(LinearProgress)(() => ({
  width: 75,
  height: 10,
  borderRadius: 2,
}));

const TelemetryHealthBar = ({ bound, status }) => {
  const classes = useStyles();
  const deriveBarBounds = (bound) => {
    const maxBounds = 7;
    const increments = 100 / maxBounds;

    let sizeOfBar = increments * bound + maxBounds;

    if (sizeOfBar > 100) {
      sizeOfBar = 100;
    }
    return sizeOfBar;
  };

  return (
    <div className={classes[status]}>
      <BorderLinearProgress variant="determinate" value={deriveBarBounds(bound)} sx={{ height: '400px' }} />
    </div>
  );
};

TelemetryHealthBar.propTypes = {
  bound: PropTypes.number,
  status: PropTypes.string,
};

TelemetryHealthBar.defaultProps = {
  bound: 0,
  status: '',
};

export default TelemetryHealthBar;
